
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkIssueGrid extends Serenity.EntityGrid<JobWorkIssueRow, any> {
        protected getColumnsKey() { return 'Production.JobWorkIssue'; }
        protected getDialogType() { return JobWorkIssueDialog; }
        protected getIdProperty() { return JobWorkIssueRow.idProperty; }
        protected getInsertPermission() { return JobWorkIssueRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkIssueRow.localTextPrefix; }
        protected getService() { return JobWorkIssueService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(69);
            this.editItem(<JobWorkIssueRow>{
                VoucherNo: voucherNo,
                UserId: Q.Authorization.userDefinition.UserId,
                VoucherTypeId: 69,
                EmployeeId: 0,
                TransDate: now.toString(),
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,

            });
        }
    }
}